export const theme = {
  screenSize: {
    xxs: '320px',
    xs: '576px',
    sm: '768px',
    md: '992px',
    lg: '1200px',
  },
};
